import axios from 'axios';
import prepareRequestOptions from '../utils/admin-apis.util';

export const getSearchListData = async () => {
  const options = prepareRequestOptions(
    '/admin/ftp/search-list',
    'GET',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const createNewData = async (payload) => {
  const options = prepareRequestOptions(
    '/admin/ftp/create',
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const viewDataById = async (id) => {
  const options = prepareRequestOptions(
    `/admin/ftp/${id}/view`,
    'GET',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const updateDataById = async (id, payload) => {
  const options = prepareRequestOptions(
    `/admin/ftp/${id}/update`,
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const deleteDataById = async (id) => {
  const options = prepareRequestOptions(
    `/admin/ftp/${id}/delete`,
    'DELETE',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const connectFTPServer = async (id) => {
  const options = prepareRequestOptions(
    `/admin/ftp/${id}/connect`,
    'POST',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const getFTPFilesListData = async (id, params = '', signal = null) => {
  const options = prepareRequestOptions(
    `/admin/ftp/${id}/list${params}`,
    'GET',
    null,
    true,
    signal
  );

  const response = await axios(options);
  return response.data;
};

export const transcodeFTPFiles = async (id, payload) => {
  const options = prepareRequestOptions(
    `/admin/ftp/${id}/files/transcode`,
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const checkFileStatus = async (id) => {
  const options = prepareRequestOptions(
    `/admin/ftp/transcoded-files/${id}/status/check`,
    'GET',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const cancelTranscodingJob = async (id) => {
  const options = prepareRequestOptions(
    `/admin/ftp/transcoded-files/${id}/cancel-job`,
    'POST',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const processAgainTranscoding = async (id) => {
  const options = prepareRequestOptions(
    `/admin/ftp/transcoded-files/${id}/process-again`,
    'POST',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};
